import axios from "axios";

export async function client(endpoint, body, requestType, appURL) {

    try {

        let url = `${appURL}/${endpoint}`;

        let requestConfig = {
            method: requestType,
            url: url,
            data: body,
            headers: {
                "Content-Type": "application/json"
            }
        }
        const response = await axios(requestConfig);
        return { statusCode: response.status, data: response.data }
    } catch (error) {

        return { error: error.request.status, data: error.message }
    }
}


export async function clientFunc(body, requestType) {

    try {

        let url = `https://www.cfs.canon.com/liProxy/ContactUs/Contact`;
        //let url = 'https://localhost:7042/ContactUs/Contact';

        let requestConfig = {
            method: requestType,
            url: url,
            data: body,
            headers: {
                "Content-Type": "application/json"
            }
        }
        const response = await axios(requestConfig);
        return response
    } catch (error) {
        return error
    }
}